/* global Sys, Services */
Sys.ns("Services");

/**
 * ### Integration
 *
 * Handle actions and bundle features regards OSS.
 *
 * Handles:
 * - 'Load Progress'
 * - 'Spin Gift'
 * - 'Balance Id'
 * - 'Free Rounds'
 */
Services.Integration = {

    constructor: function() {
        Services.Integration.superclass.constructor.apply(this, arguments);

        this._loadingProgress = Services.IntegrationLoadProgress;
        this._balanceId = Services.IntegrationBalanceId.init(this);
        this._freeRounds = Services.IntegrationFreeRounds.init(this);
        this._spinGift = Services.IntegrationSpinGift.init(this);
    },

    /**
     * Start reporting loading progress to OSS.
     *
     * @public
     * @param {Object} loadProgressHandler LoadProgressHandler class instance.
     * @returns {void}
     */
    startReportingLoadingProgress: function(loadProgressHandler) {
        this._loadingProgress.startReporting(loadProgressHandler);
    },

    /**
     * Handles updates about balanceId from OSS.
     *
     * Saves a new balance to be included in a new requests to the server.
     *
     * Request a new init action from the server.
     *
     * @param {string} newBalanceId New balanceId.
     * @returns {void}
     */
    handleBalanceIdUpdate: function(newBalanceId) {
        this._balanceId.handleUpdate(newBalanceId);
    },

    /**
     * Handles updates about spin gifts feature from OSS.
     *
     * Currently handles statuses: rewardAvailable and active.
     *
     * @param {string} status New status.
     * @returns {void}
     */
    handleSpinGiftsStatusUpdate: function(status) {
        this._spinGift.handleStatusUpdate(status);
    },

    /**
     * Either game is in Spin Gift feature or not.
     *
     * @returns {boolean} Return true if in Spin Gift feature.
     */
    isInSpinGift: function() {
        return this._spinGift.isInSpinGift();
    },

    /**
     * Handles dialog request in Free Rounds.
     *
     * @param {string} dialogName Name of dialog that was requested.
     * @returns {void}
     */
    handleFreeRoundsDialog: function(dialogName) {
        this._freeRounds.handleDialog(dialogName);
    },

    /**
     * Handles dialog request in Spin Gift.
     *
     * @param {string} dialogName Name of dialog that was requested.
     * @returns {void}
     */
    handleSpinGiftDialog: function(dialogName) {
        this._spinGift.handleDialog(dialogName);
    }
};

Services.Integration = Sys.extend(Sys.Observable, Services.Integration, "Services.Integration");
